import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status", "outcome", "submit"]

  connect() {
    this.updateStatus()
  }

  updateStatus() {
    if (this.hasOutcomeTarget) this.outcomeTarget.classList.toggle("hidden", !this.completed)
    if (this.hasSubmitTarget) this.submitTarget.textContent = this.completed ? "Log activity" : "Schedule activity"
  }

  get completed() {
    return this.statusTargets.some(radio => radio.checked && radio.value === "completed")
  }
}
